import { createWidget } from '@alfa-bank/site-util-create-widget';

import { GeoField as Component } from './geo-field';
import type { IProps } from './models';

export const GeoField = createWidget<unknown, IProps>()(Component);
